import React, { useState } from 'react'

import {
  TableContainerStyled,
  TableBodyStyled,
  TableCellStyled,
  TableFooter,
  TableHeadStyled,
  TableRowStyled,
  TableStyled,
  Row
} from 'components'
import moment from 'moment'
import { ViewFileIcon } from 'components/Icons'
import ViewEmailBody from '../../../../../../../components/ViewEmailBody/ViewEmailBody'
import { useModal, useToggle } from 'hooks'

// import { Container } from './styles';
interface ITableJobs {
  tableData: any[]
  page: number
  setPage: any
  totalItems: number
  pageSize: number
  setPageSize: any
}
const TableJobs: React.FC<ITableJobs> = ({
  tableData,
  page,
  setPage,
  totalItems,
  pageSize,
  setPageSize
}) => {
  // const [page, setPage] = React.useState(0)
  // const [rowsPerPage, setRowsPerPage] = React.useState(15)

  const handleChangePage = (newPage: number) => setPage(newPage)

  const [emailBodyJobSelected, setEmailBodyJobSelected] = useState<any>()
  const [openEmailBodyModal, toggleEmailBodyModal] = useToggle()
  const { showModal } = useModal()

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setPageSize(parseInt(event.target.value, 10))
    setPage(0)
  }

  const handleShowEmailJobModal = (txCorpoEmail: string) => {
    if (txCorpoEmail === null || txCorpoEmail === undefined) {
      showModal({
        hideButtonCancel: true,
        message: 'Não é possivel visualizar o corpo do email.',
        type: 'alert',
        txtButtonConfirm: 'Fechar'
      })
      return
    }

    setEmailBodyJobSelected(txCorpoEmail)
    toggleEmailBodyModal()
  }
  const safeToUpperCase = (value) => (value ? value.toString().toUpperCase() : 'N/A');

  return (
    <>
      <TableContainerStyled>
        <TableStyled>
          <TableHeadStyled>
            <TableRowStyled>
              <TableCellStyled align="left">Destinatário</TableCellStyled>
              <TableCellStyled align="left">
                E-mail Destinatário
              </TableCellStyled>
              <TableCellStyled align="left">Data Envio</TableCellStyled>
              <TableCellStyled align="left">Matrícula</TableCellStyled>
              <TableCellStyled align="left">Nome Contraparte</TableCellStyled>
              <TableCellStyled align="left">Tipo</TableCellStyled>
              <TableCellStyled align="left">Ações</TableCellStyled>
            </TableRowStyled>
          </TableHeadStyled>
          <TableBodyStyled>
            {tableData.map((row) => (
              <TableRowStyled key={row}>
                <TableCellStyled align="left">
                  {safeToUpperCase(row.nmFornecedor)}
                </TableCellStyled>
                <TableCellStyled align="left">
                  {safeToUpperCase(row.txEmailResponsavel)}
                </TableCellStyled>
                <TableCellStyled align="left">
                  {(safeToUpperCase(moment(row.dtEnvioEmail).format('DD/MM/YYYY')))}
                </TableCellStyled>
                <TableCellStyled align="left">
                  {safeToUpperCase(row.cdMatriculaContraparte)}
                </TableCellStyled>
                <TableCellStyled align="left">
                  {safeToUpperCase(row.nmContraparte)}
                </TableCellStyled>
                <TableCellStyled align="left">{safeToUpperCase(row.nmTipoJOB)}</TableCellStyled>
                <TableCellStyled align="center">
                  <Row justifyContent="center" alignItems="center">
                    <ViewFileIcon
                      cursor="pointer"
                      onClick={() => handleShowEmailJobModal(safeToUpperCase(row.txCorpoEmail))}
                    />
                  </Row>
                </TableCellStyled>
              </TableRowStyled>
            ))}
          </TableBodyStyled>
        </TableStyled>
      </TableContainerStyled>
      <TableFooter
        page={page}
        rows={tableData}
        totalItems={totalItems}
        rowsPerPage={pageSize}
        handleChangePage={handleChangePage}
        handleChangeRowsPerPage={handleChangeRowsPerPage}
      />
      <ViewEmailBody
        showModal={openEmailBodyModal}
        emailBody={emailBodyJobSelected}
        toggleModal={toggleEmailBodyModal}
      />
    </>
  )
}

export default TableJobs
